import React from 'react';
import { motion } from 'framer-motion';
export function Features() {
  return <section id="features" className="py-24 border-b border-stone-300" data-id="element-855">
      <div className="max-w-6xl mx-auto px-6" data-id="element-856">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-857">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-858">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-859">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-860">
                Platform
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-900 mb-6" data-id="element-861">
                Everything you need to quote, hold, and close
              </h2>

              <p className="text-lg text-stone-600 leading-relaxed" data-id="element-862">
                A complete operating system for group travel distribution. Built
                for revenue teams who need control.
              </p>
            </div>

            {/* Right: Feature list */}
            <div className="lg:col-span-8" data-id="element-863">
              <div className="border-t border-stone-300" data-id="element-864">
                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-865">
                  <div className="col-span-1" data-id="element-866">
                    <span className="font-mono text-xs text-stone-400" data-id="element-867">01</span>
                  </div>
                  <div className="col-span-4" data-id="element-868">
                    <p className="font-medium text-stone-900" data-id="element-869">
                      Multi-Property Quotes
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-870">
                    <p className="text-stone-600" data-id="element-871">
                      Instant quotes across your entire portfolio. Room blocks,
                      dates, occupancy, event needs—handled in seconds.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-872">
                  <div className="col-span-1" data-id="element-873">
                    <span className="font-mono text-xs text-stone-400" data-id="element-874">02</span>
                  </div>
                  <div className="col-span-4" data-id="element-875">
                    <p className="font-medium text-stone-900" data-id="element-876">Smart Holds</p>
                  </div>
                  <div className="col-span-7" data-id="element-877">
                    <p className="text-stone-600" data-id="element-878">
                      Automated hold timers with expiry management. Inventory
                      secured, no manual follow-ups required.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-879">
                  <div className="col-span-1" data-id="element-880">
                    <span className="font-mono text-xs text-stone-400" data-id="element-881">03</span>
                  </div>
                  <div className="col-span-4" data-id="element-882">
                    <p className="font-medium text-stone-900" data-id="element-883">
                      Package Builder
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-884">
                    <p className="text-stone-600" data-id="element-885">
                      Good / Better / Best options auto-generated within your
                      pricing policy. Maximize conversion, protect margins.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-886">
                  <div className="col-span-1" data-id="element-887">
                    <span className="font-mono text-xs text-stone-400" data-id="element-888">04</span>
                  </div>
                  <div className="col-span-4" data-id="element-889">
                    <p className="font-medium text-stone-900" data-id="element-890">
                      Proposal Generation
                    </p>
                  </div>
                  <div className="col-span-7" data-id="element-891">
                    <p className="text-stone-600" data-id="element-892">
                      Standardized, branded proposals exported in one click.
                      Ready for client presentation.
                    </p>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-300 grid grid-cols-12 gap-4" data-id="element-893">
                  <div className="col-span-1" data-id="element-894">
                    <span className="font-mono text-xs text-stone-400" data-id="element-895">05</span>
                  </div>
                  <div className="col-span-4" data-id="element-896">
                    <p className="font-medium text-stone-900" data-id="element-897">Policy Engine</p>
                  </div>
                  <div className="col-span-7" data-id="element-898">
                    <p className="text-stone-600" data-id="element-899">
                      Rate floors, blackout dates, concession limits—enforced
                      automatically across all quotes.
                    </p>
                  </div>
                </div>

                <div className="py-6 grid grid-cols-12 gap-4" data-id="element-900">
                  <div className="col-span-1" data-id="element-901">
                    <span className="font-mono text-xs text-stone-400" data-id="element-902">06</span>
                  </div>
                  <div className="col-span-4" data-id="element-903">
                    <p className="font-medium text-stone-900" data-id="element-904">Audit Trail</p>
                  </div>
                  <div className="col-span-7" data-id="element-905">
                    <p className="text-stone-600" data-id="element-906">
                      Every quote, change, and approval tracked and reportable.
                      Complete visibility for revenue teams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}